export default __webpack_public_path__ + "static/media/pumpkins.792b6167.jpg";